
export const alpha_spaces = (value) => {
    return value && value.match(/^[a-zA-Z\s'.]+$/) !== null
};

export const alpha_num_spaces = (value) => {
    return value && value.match(/^[\w\s-/]+$/) !== null
};

export const spid = (value) => {
    return value && value.trim().match(/^\d{3}[\da-zA-Z]$/) !== null
};

export const email = (value) => {
    if (!value) return true;
    let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return value.match(validRegex) ? true : false;
}

export const phonenumber = (value, vm) => {
    if (!value) return false;
    value = value.trim();
    if (value.match(/^\((\d{3})\) (\d{3})-(\d{4})$/)) return true;
    value = ('' + value).replace(/\D/g, '');
    value = (value.length === 10) ? '1'.concat(value) : value;  // add 1 if it's 10-digits number
    let match = value.match(/^1(\d{3})(\d{3})(\d{4})$/);
    if (match)
    {
        vm.billing_telephone_number = '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return match !== null
};

export const phonenumbers_list = (value, vm) => {
    let BreakException = {};

    if (!value) return false;
    let phonenumbers = value.split(/[\n,]+/)
    let formatted = []
    try {
        phonenumbers.forEach((element) => {
            element = element.trim();
            if (element.match(/^\((\d{3})\) (\d{3})-(\d{4})$/)) {
                formatted.push(element);
            }
            else {
                element = ('' + element).replace(/\D/g, '');
                element = (element.length === 10) ? '1'.concat(element) : element;
                let match = element.match(/^1(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    formatted.push('(' + match[1] + ') ' + match[2] + '-' + match[3])
                } else {
                    throw BreakException;
                }
            }
        })
    } catch (e) {
        return false;
    }
    vm.phone_numbers = formatted.join(', ')
    return true;
}
